export function createBaseResponseErrors (singular, plural) {
  return {
    getAll: 'Не удалось загрузить список ' + plural,
    getById: 'Не удалось загрузить ' + singular,
    create: 'Не удалось создать ' + singular,
    update: 'Не удалось обновить ' + singular,
    destroy: 'Не удалось удалить ' + singular,
    destroyList: 'Не удалось удалить список' + plural
  }
}

export function createFilesResponseErrors () {
  return {
    postFiles: 'Не удалось загрузить файл',
    deleteFiles: 'Не удалось удалить файл'
  }
}

export function createUniqueError (name) {
  return {
    createUnique: `${name} уже существует в справочнике. Пожалуйста, выберете значение в списке`
  }
}
